import { ElementRef, EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import { User } from '../../../../core/user/user.model';
import * as momenttz from "moment-timezone";
import moment from "moment";
import { ChangeAttributes } from '../../../session/schedule-session/change-attributes';
import { ConfirmAttributes } from '../../../session/schedule-session/confirm-attributes';
import { SessionCreateDTO } from '../../../session/schedule-session/session-create-dto';
import { DialogAttributes } from '../../../session/schedule-session/dialog-attributes';
import { PaymentService } from '../../../payment/payment.service';
import { UserService } from '../../../../core/user/user.service';
import { UserVoucherService } from '../../../user-voucher/user-voucher.service';
import { PricingService } from '../../../pricing/pricing.service';
import { SessionService } from '../../../session/session.service';
import { AccountService } from '../../../../core/auth/account.service';
import { SessionSettingService } from '../../../session-setting/session-setting.service';
import { ActivatedRoute, Router } from "@angular/router";
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import { JhiEventManager } from '../../../../ng-jhipster/service';
import { TrackerService } from '../../../../core/tracker/tracker.service';
import { CoachDetailsService } from '../../../slot/coach-details.service';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from '../../../../shared/base.component';
import { SessionScheduledPopupComponent } from '../../../session/schedule-session/session-scheduled-popup/session-scheduled-popup.component';
import { AvailableCoachSlotsCalendar } from '../../../session/schedule-session/available-coach-slots/available-coach-slots-calendar.model';
import { AvailableCoachSlots } from '../../../session/schedule-session/available-coach-slots/available-coach-slots.model';
import { CalendarEventLinkService } from '../../../../core/util/calendar-event-link.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../../core/user/user.service";
import * as i2 from "../../../user-voucher/user-voucher.service";
import * as i3 from "../../../pricing/pricing.service";
import * as i4 from "../../../session/session.service";
import * as i5 from "../../../payment/payment.service";
import * as i6 from "../../../../core/auth/account.service";
import * as i7 from "../../../session-setting/session-setting.service";
import * as i8 from "@angular/router";
import * as i9 from "../../../../ng-jhipster/service";
import * as i10 from "../../../../ng-jhipster/language";
import * as i11 from "../../../../core/tracker/tracker.service";
import * as i12 from "../../../slot/coach-details.service";
import * as i13 from "ngx-webstorage";
import * as i14 from "@ng-bootstrap/ng-bootstrap";
import * as i15 from "../../../../core/util/calendar-event-link.service";
import * as i16 from "@angular/common";
import * as i17 from "../available-coach-slots/available-coach-slots-calendar/available-coach-slots-calendar.component";
import * as i18 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i19 from "../session-language-radio-selector/session-language-radio-selector.component";
const _c0 = ["warningSelectedTimeSlotIsNoLongerValidDialog"];
const _c1 = ["alreadyFutureSessionDialog"];
const _c2 = ["alreadyFutureSessionDialogForCoach"];
const _c3 = ["okDialog"];
const _c4 = ["dialogBox"];
const _c5 = ["paymentCancelledDialogBox"];
const _c6 = ["paymentCannotBeVerifiedDialogBox"];
const _c7 = ["paymentIsBeingProcessedDialogBox"];
const _c8 = ["noCredit"];
const _c9 = ["noCreditForCoach"];
function ScheduleSessionCoachComponent_available_coach_slots_calendar_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "available-coach-slots-calendar", 10);
    i0.ɵɵlistener("selectedDateChange", function ScheduleSessionCoachComponent_available_coach_slots_calendar_2_Template_available_coach_slots_calendar_selectedDateChange_0_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.onSelectedDayChange($event); })("showNextPeriod", function ScheduleSessionCoachComponent_available_coach_slots_calendar_2_Template_available_coach_slots_calendar_showNextPeriod_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.showNextPeriod(); })("showPreviousPeriod", function ScheduleSessionCoachComponent_available_coach_slots_calendar_2_Template_available_coach_slots_calendar_showPreviousPeriod_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.showPreviousPeriod(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("availableCoachSlotsCalendar", ctx_r0.availableCoachSlotsCalendar)("viewMode", ctx_r0.viewMode);
} }
function ScheduleSessionCoachComponent_ng_container_5_ng_container_1__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 17);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionCoachComponent_ng_container_5_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 16);
    i0.ɵɵelement(1, "use", 18);
    i0.ɵɵelementEnd();
} }
const _c10 = function (a0) { return { value: a0 }; };
function ScheduleSessionCoachComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_ng_container_5_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const allowedDuration_r13 = restoredCtx.$implicit; const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.switchAvailableSessionTypeTab("text", allowedDuration_r13); });
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, ScheduleSessionCoachComponent_ng_container_5_ng_container_1__svg_svg_3_Template, 2, 0, "svg", 13);
    i0.ɵɵtemplate(4, ScheduleSessionCoachComponent_ng_container_5_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 14);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7, " \u00A0(");
    i0.ɵɵelement(8, "span", 15);
    i0.ɵɵtext(9, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r13 = ctx.$implicit;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r12.sessionType === "text" && ctx_r12.duration == allowedDuration_r13);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r12.sessionType === "text" && ctx_r12.duration == allowedDuration_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.sessionType !== "text" || ctx_r12.duration != allowedDuration_r13);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c10, allowedDuration_r13));
} }
function ScheduleSessionCoachComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionCoachComponent_ng_container_5_ng_container_1_Template, 10, 7, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.sessionDurationByType.text);
} }
function ScheduleSessionCoachComponent_ng_container_6_ng_container_1__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 21);
    i0.ɵɵelement(1, "use", 22);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionCoachComponent_ng_container_6_ng_container_1__svg_svg_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 21);
    i0.ɵɵelement(1, "use", 23);
    i0.ɵɵelementEnd();
} }
function ScheduleSessionCoachComponent_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_ng_container_6_ng_container_1_Template_div_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r23); const allowedDuration_r19 = restoredCtx.$implicit; const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.switchAvailableSessionTypeTab("video", allowedDuration_r19); });
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, ScheduleSessionCoachComponent_ng_container_6_ng_container_1__svg_svg_3_Template, 2, 0, "svg", 19);
    i0.ɵɵtemplate(4, ScheduleSessionCoachComponent_ng_container_6_ng_container_1__svg_svg_4_Template, 2, 0, "svg", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "span", 20);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7, " \u00A0(");
    i0.ɵɵelement(8, "span", 15);
    i0.ɵɵtext(9, ") ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const allowedDuration_r19 = ctx.$implicit;
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("selected-tab", ctx_r18.sessionType === "video" && ctx_r18.duration == allowedDuration_r19);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r18.sessionType === "video" && ctx_r18.duration == allowedDuration_r19);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r18.sessionType !== "video" || ctx_r18.duration != allowedDuration_r19);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(5, _c10, allowedDuration_r19));
} }
function ScheduleSessionCoachComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ScheduleSessionCoachComponent_ng_container_6_ng_container_1_Template, 10, 7, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.sessionDurationByType.video);
} }
function ScheduleSessionCoachComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelementStart(1, "button", 27);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_div_7_div_1_Template_button_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r28); const date_r25 = restoredCtx.$implicit; const slotIndex_r26 = restoredCtx.index; const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.selectHour(ctx_r27.hourOfDate(date_r25), ctx_r27.selectedDayAvailableCoachSlots.coachesSlots[0], slotIndex_r26, 2, date_r25); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r25 = ctx.$implicit;
    const slotIndex_r26 = ctx.index;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r24.isSlotSelected(slotIndex_r26) ? "hour-number-selected" : "")("disabled", ctx_r24.futureSessionExists || (ctx_r24.credit == null ? null : ctx_r24.credit.message) != null && (ctx_r24.credit == null ? null : ctx_r24.credit.message) === "noCreditForCoach");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r24.hourOfDate(date_r25), " ");
} }
function ScheduleSessionCoachComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, ScheduleSessionCoachComponent_div_7_div_1_Template, 3, 3, "div", 25);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.selectedDayAvailableCoachSlots.coachesSlots[0].sessionStartTimes);
} }
function ScheduleSessionCoachComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵelement(2, "h4", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ScheduleSessionCoachComponent_div_9_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 33);
    i0.ɵɵelement(2, "span", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(4, "svg", 52);
    i0.ɵɵelement(5, "use", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(6, "span", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵattribute("href", "../../../../../../../../content/images/sprite.svg?v=3#duration-clock", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(2, _c10, ctx_r29.duration));
} }
function ScheduleSessionCoachComponent_div_9_button_29_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 54);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_div_9_button_29_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r33); const ctx_r32 = i0.ɵɵnextContext(2); return ctx_r32.confirmSelection(); });
    i0.ɵɵelementEnd();
} }
function ScheduleSessionCoachComponent_div_9_button_30_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 55);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_div_9_button_30_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(2); return ctx_r34.confirmSelection(); });
    i0.ɵɵelementEnd();
} }
const _c11 = function (a0) { return { "margin-top": a0 }; };
const _c12 = function (a0, a1) { return { date: a0, time: a1 }; };
function ScheduleSessionCoachComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵelement(2, "div", 32);
    i0.ɵɵelementStart(3, "div", 0);
    i0.ɵɵelementStart(4, "div", 33);
    i0.ɵɵelement(5, "span", 34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 35);
    i0.ɵɵelementStart(7, "span", 36);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 30);
    i0.ɵɵelementStart(10, "div", 33);
    i0.ɵɵelement(11, "span", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 35);
    i0.ɵɵelementStart(13, "p", 38);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(14, "svg", 39);
    i0.ɵɵelement(15, "use", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(16, "span", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 30);
    i0.ɵɵelementStart(18, "div", 33);
    i0.ɵɵelement(19, "span", 42);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 35);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(21, "svg", 43);
    i0.ɵɵelement(22, "use", 40);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(23, "span", 44);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, ScheduleSessionCoachComponent_div_9_div_24_Template, 7, 4, "div", 8);
    i0.ɵɵelementStart(25, "div", 45);
    i0.ɵɵelementStart(26, "session-language-radio-selector", 46);
    i0.ɵɵlistener("sessionLanguageChange", function ScheduleSessionCoachComponent_div_9_Template_session_language_radio_selector_sessionLanguageChange_26_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(); return ctx_r36.sessionLanguage = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 47);
    i0.ɵɵelementStart(28, "button", 48);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_div_9_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r37); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.cancel(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, ScheduleSessionCoachComponent_div_9_button_29_Template, 1, 0, "button", 49);
    i0.ɵɵtemplate(30, ScheduleSessionCoachComponent_div_9_button_30_Template, 1, 0, "button", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(ctx_r5.user.login);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c11, ctx_r5.sessionType === "video" ? "4px" : "0"));
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("href", "../../../../../../../../content/images/sprite.svg?v=3#" + ctx_r5.sessionType + "-green", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionSchedule.paragraph." + ctx_r5.sessionType);
    i0.ɵɵadvance(6);
    i0.ɵɵattribute("href", "../../../../../../../../content/images/sprite.svg?v=3#calendar-green", null, "xlink");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(13, _c12, ctx_r5.confirmAttributes.selectedDate.format("dddd, DD MMMM"), ctx_r5.confirmAttributes.hour));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.sessionDurationByType != null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sessionLanguageList", ctx_r5.sessionLanguageList)("sessionLanguage", ctx_r5.sessionLanguage);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r5.isReschedule);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.isReschedule);
} }
function ScheduleSessionCoachComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵelement(1, "h3", 57);
    i0.ɵɵelement(2, "div", 58);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 59);
    i0.ɵɵelementStart(4, "button", 60);
    i0.ɵɵlistener("click", function ScheduleSessionCoachComponent_ng_template_10_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.refreshAvailabilities(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
export class ScheduleSessionCoachComponent extends BaseComponent {
    constructor(userService, userVoucherService, pricingService, sessionService, paymentService, accountService, sessionSettingService, route, router, eventManager, languageService, trackerService, coachDetailsService, elementRef, sessionStorage, modalService, calendarEventLinkService) {
        super(sessionStorage, modalService);
        this.userService = userService;
        this.userVoucherService = userVoucherService;
        this.pricingService = pricingService;
        this.sessionService = sessionService;
        this.paymentService = paymentService;
        this.accountService = accountService;
        this.sessionSettingService = sessionSettingService;
        this.route = route;
        this.router = router;
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.trackerService = trackerService;
        this.coachDetailsService = coachDetailsService;
        this.elementRef = elementRef;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.calendarEventLinkService = calendarEventLinkService;
        this.MAX_AUTO_LOOKUP_TRIES = 6;
        this.onScheduleSession = new EventEmitter();
        this.onScheduleSessionText = new EventEmitter();
        this.onHourPressed = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.timezones = momenttz.tz.names();
        this.selectedTimezone = momenttz.tz.guess();
        this.today = moment();
        this.viewMode = "monthly";
        this.isScheduleSession = this.router.url.includes('/schedule-session');
        this.isIndexCoach = this.router.url.includes('/index-coach');
        this.bookSessionStyle = { padding: '3rem!important', marginTop: '1.5rem!important' };
        this.indexCoachStyle = {};
        this.sessionLanguageList = [];
        this.sessionType = 'text';
        this.isCoach = this.accountService.isCoach();
        this.isUser = this.accountService.isUser();
        this.isCoronaUser = false;
        this.headerWord = 'recommendChat';
        this.isVideo = false;
        this.selectedSessionTypes = ['text'];
        this.autoLookupTries = 0;
        this.availableSessionTypeTab = "text";
        this.selectedCoachIndex = -1;
        this.selectedSlotIndex = -1;
        this.scheduling = false;
    }
    set sessionId(value) {
        this._sessionId = value;
        if (value) {
            this.isReschedule = true;
        }
    }
    get sessionId() {
        return this._sessionId;
    }
    set sessionLanguage(value) {
        this._sessionLanguage = value;
    }
    get sessionLanguage() {
        return this._sessionLanguage;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F8F7F2';
        if (this.user) {
            this.renderComponent();
        }
        // this.sessionListModificationEventSubscription = this.eventManager.subscribe("sessionListModification", () => { this.renderComponent() });
    }
    ngOnChanges(changes) {
        this.renderComponent();
    }
    renderComponent() {
        this.langKey = this.languageService.getCurrentLanguage();
        this.userService.getCoachReasoningLanguages(this.coach.id).subscribe((res) => {
            this.sessionLanguageList = res;
            console.log(this.sessionLanguage);
        });
        this.futureSessionExists = false;
        this.getSessionCounts(this.user.id);
        this.getSessionDuration(this.user.id);
        // this.code = "Enter your voucher code here";
        this.dialogAttributes = new DialogAttributes();
        this.initAvailablePeriodStartDay();
        this.loadAvailableCoachSlots();
        this.changeAttributes = new ChangeAttributes();
        this.changeAttributes.hid = true;
    }
    initAvailablePeriodStartDay() {
        if (this.viewMode === "weekly") {
            this.availablePeriodStart = AvailableCoachSlotsCalendar.getCurrentWeekStartingDay(this.selectedTimezone);
        }
        else if (this.viewMode === "monthly") {
            this.availablePeriodStart = AvailableCoachSlotsCalendar.getCurrentMonthStartingDay(this.selectedTimezone);
        }
    }
    getSessionDuration(userId) {
        this.sessionSettingService.getSessionDurationByUserAndCoach(userId, this.coach.id).subscribe(sessionDurationByType => {
            this.sessionDurationByType = sessionDurationByType.body;
            if (!this.duration) {
                this.selectDefaultSessionDuration();
            }
            this.updateAvailableSessionTypes();
        });
    }
    getSessionCounts(userId) {
        if (this.accountService.isUser()) {
            this.sessionService.getAllSessionsCountUserByUser().subscribe((res) => {
                console.log(res);
                this.userSessionCount = res;
            });
            this.sessionService.getAllTextSessionsCountUserByUser().subscribe((res) => {
                console.log(res);
                this.textSessionCount = res;
            });
        }
        else if (this.accountService.isCoach() || this.accountService.isCustomerCare()) {
            this.sessionService.getAllSessionsCountUserByCoach(userId).subscribe((res) => {
                console.log(res);
                this.userSessionCount = res;
            });
            this.sessionService.getAllTextSessionsCountUserByCoach(userId).subscribe((res) => {
                console.log(res);
                this.textSessionCount = res;
            });
        }
    }
    displayOkDialog(paymentAndSessionData) {
        this.open(this.okDialog);
    }
    smoothScrollToElement(elementId) {
        const scrollToElement = window.setTimeout(() => {
            const pos = window.pageYOffset;
            const element = document.getElementById(elementId);
            element.scrollIntoView({ 'behavior': 'smooth' });
            // window.scrollTo(0, element.offsetTop);
        }, 100);
    }
    selectHour(hour, coachSlots, slotIndex, num, date) {
        this.momentDate = date;
        this.changeAttributes.hid = false;
        this.changeAttributes.voucherhid = true;
        this.selectedSlotIndex = slotIndex;
        this.confirmAttributes = new ConfirmAttributes(this.langKey, moment(date), hour, coachSlots.coach, date);
        let coachId = this.confirmAttributes.coach.id;
        this.videoChatEnabled = coachSlots.coachDetails.videoChatEnabled;
        this.textChatEnabled = coachSlots.coachDetails.textChatEnabled;
        this.updateAvailableSessionTypes();
        if (this.isReschedule) {
            this.smoothScrollToElement('session-schedule-confirm-newtime-selection-btn');
        }
        else {
            this.smoothScrollToElement('session-schedule-confirm-selection-btn');
        }
    }
    smoothScrollToElementForCoach(elementId) {
        this.onHourPressed.emit(elementId);
    }
    loadAvailableCoachSlots() {
        var _a;
        this.langKey = this.languageService.getCurrentLanguage();
        // console.log("displayWeek");
        let numberOfDays = 7;
        if (this.viewMode === "monthly") {
            numberOfDays = AvailableCoachSlotsCalendar.getTotalDaysInMonth(this.availablePeriodStart, this.selectedTimezone);
        }
        if (this.availableSessionsObservable && !this.availableSessionsObservable.closed) {
            this.availableSessionsObservable.unsubscribe();
        }
        let request = {
            numberOfDays,
            dateTime: this.availablePeriodStart,
            userId: (_a = this.user) === null || _a === void 0 ? void 0 : _a.id,
            coachId: null,
            languages: this.selectedSessionLanguages,
            sessionTypes: this.selectedSessionTypes,
            duration: this.duration
        };
        if (this.coach) {
            request.coachId = this.coach.id;
        }
        console.log(request);
        let isScheduled;
        if (this.isReschedule) {
            isScheduled = "update";
        }
        const isAutoLookup = this.autoLookupTries > 0;
        this.availableSessionsObservable = this.sessionService.sessionAvailable(request, isScheduled, this.sessionId, isAutoLookup).subscribe(response => {
            var _a;
            if ((_a = response === null || response === void 0 ? void 0 : response.coachesSlots) === null || _a === void 0 ? void 0 : _a.length) {
                const availableCoachSlots = new AvailableCoachSlots(response);
                this.availableCoachSlotsCalendar = new AvailableCoachSlotsCalendar(availableCoachSlots, this.availablePeriodStart, this.viewMode, this.selectedTimezone);
                this.resetAutoLookupTries();
            }
            else {
                this.availableCoachSlotsCalendar = new AvailableCoachSlotsCalendar(null, this.availablePeriodStart, this.viewMode, this.selectedTimezone);
                this.selectedDayAvailableCoachSlots = null;
                this.tryToLookupSlotInTheNextDays();
            }
        }, () => console.log("Error fetching sessionsAvailable() service"));
    }
    tryToLookupSlotInTheNextDays() {
        if (this.autoLookupTries < this.MAX_AUTO_LOOKUP_TRIES) {
            this.autoLookupTries++;
            this.showNextPeriod();
        }
        else {
            // max tries reached
            console.warn('I did my best to find an available slots :(');
        }
    }
    resetAutoLookupTries() {
        this.autoLookupTries = 0;
    }
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: "modal-basic-title", backdrop: "static", keyboard: false });
    }
    closeAll() {
        this.modalService.dismissAll();
    }
    close() {
        this.closeAll();
        this.smoothScrollUp();
        if (this.isScheduleSession)
            this.router.navigate(["/index-user"]).then();
    }
    smoothScrollUp() {
        const scrollToTop = window.setTimeout(() => {
            const pos = window.pageYOffset;
            window.scrollTo(0, 0); // how far to scroll on each step
        }, 1);
    }
    isCoachSpecified(coach) {
        if (!this.coach) {
            return true; // coach is not specified, no need to filter
        }
        let b = this.coach.login === coach.login;
        return b;
    }
    getCurrentCoachLogin() {
        return this.coach.login;
    }
    currentCoachInitialized() {
        return this.coach !== undefined;
    }
    hourOfDate(date) {
        return date.tz(this.selectedTimezone).format(!this.isAmPm ? "HH:mm" : "hh:mm a");
    }
    hasSlots(slotsAndCoach) {
        return slotsAndCoach.sessionStartTimes.length > 0;
    }
    isSlotSelected(slotIndex) {
        return slotIndex === this.selectedSlotIndex;
    }
    switchAvailableSessionTypeTab(selectedTab, duration) {
        this.availableSessionTypeTab = selectedTab;
        this.sessionType = selectedTab;
        if (duration) {
            this.duration = duration;
        }
        else {
            this.selectDefaultSessionDuration();
        }
        this.onSelectedSessionTypesChanged([this.availableSessionTypeTab]);
    }
    ngOnDestroy() {
        if (this.langKeyChangedSubscription) {
            this.langKeyChangedSubscription.unsubscribe();
        }
        if (this.sessionScheduledEventSubscription) {
            this.sessionScheduledEventSubscription.unsubscribe();
        }
        if (this.sessionListModificationEventSubscription) {
            this.sessionListModificationEventSubscription.unsubscribe();
        }
        if (this.refreshAvailabilitiesRequestEventSubscription) {
            this.refreshAvailabilitiesRequestEventSubscription.unsubscribe();
        }
    }
    updateAvailableSessionTypes() {
        if (this.sessionDurationByType) {
            this.sessionTypeList = Object.keys(this.sessionDurationByType);
            if (this.textChatEnabled === false) {
                this.sessionTypeList = this.sessionTypeList.filter(value => value.indexOf('text') === -1);
            }
            if (this.videoChatEnabled === false) {
                this.sessionTypeList = this.sessionTypeList.filter(value => value.indexOf('video') === -1);
            }
            if (this.isVideo) {
                const videoSessionType = this.sessionTypeList.find(value => value.indexOf('video') !== -1);
                if (videoSessionType) {
                    this.sessionType = videoSessionType;
                }
            }
            else {
                const videoSessionType = this.sessionTypeList.find(value => value.indexOf('text') !== -1);
                if (videoSessionType) {
                    this.sessionType = videoSessionType;
                }
            }
        }
    }
    confirmSelection() {
        if (this.scheduling)
            return;
        if (this.user === undefined) {
            let tempUser = new User();
            tempUser.id = 0;
            this.user = tempUser;
        }
        if (!this.videoChatEnabled) {
            this.sessionType = 'text';
        }
        this.sessionCreateDTO = new SessionCreateDTO(this.confirmAttributes.coach.id, this.confirmAttributes.selectedDate, this.confirmAttributes.hour, this.isCoach, this.user.id, this.sessionType ? this.sessionType : 'text', this.confirmAttributes.selectedDateString, this.sessionLanguage ? this.sessionLanguage : 'en', this.duration);
        this.sessionCreateDTO.sessionId = this.sessionId;
        if (this.isReschedule) {
            this.reschedule();
        }
        else {
            this.scheduleNew(this.sessionCreateDTO, SessionScheduledPopupComponent);
            this.trackerService.sendActivity("schedule_new_session_completed");
        }
        if (this.isCoach)
            this.changeAttributes.hid = true;
    }
    scheduleNew(sessionCreateDTO, content) {
        this.scheduling = true;
        this.sessionService.scheduleSession(sessionCreateDTO).subscribe(data => {
            if (data.message === "credit") {
                this.changeAttributes.voucherhid = false;
                this.changeAttributes.hid = true;
            }
            else if (data.message === "no longer valid") {
                this.modalService.dismissAll();
                this.modalRef = this.modalService.open(this.warningSelectedTimeSlotIsNoLongerValidDialog);
            }
            else if (data.session) {
                this.onSessionScheduleSuccess(data);
                this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: this.sessionCreateDTO.sessionStartTime });
            }
            this.scheduling = false;
        }, error => {
            this.scheduling = false;
        });
    }
    reschedule() {
        this.closeAll();
        this.sessionService.reschedule(this.sessionCreateDTO).subscribe(data => {
            if (data.message === "no longer valid") {
                this.modalService.dismissAll();
                this.modalRef = this.modalService.open(this.warningSelectedTimeSlotIsNoLongerValidDialog);
            }
            else if (data.session) {
                this.onSessionScheduleSuccess(data);
                this.eventManager.broadcast({ name: 'customerCareInfoUpdated', content: this.sessionCreateDTO.sessionStartTime });
            }
        });
    }
    onSessionScheduleSuccess(data) {
        this.onScheduleSession.emit(data.session);
        this.openSessionScheduledPopup(data);
        this.eventManager.broadcast("sessionListModification");
    }
    openSessionScheduledPopup(scheduleSessionResponse) {
        if (this.sessionCreateDTO) {
            this.createCalendarReminders(scheduleSessionResponse.session);
        }
        this.modalService.dismissAll();
        const modalRef = this.modalService.open(SessionScheduledPopupComponent, { ariaLabelledBy: "modal-basic-title", backdrop: "static", keyboard: false });
        modalRef.componentInstance.selectedUser = this.user;
        modalRef.componentInstance.confirmAttributes = this.confirmAttributes;
        modalRef.componentInstance.sessionType = this.sessionType;
        modalRef.componentInstance.responseDTO = scheduleSessionResponse;
        modalRef.componentInstance.isCoach = this.isCoach;
        modalRef.componentInstance.isCoronaUser = this.isCoronaUser;
        modalRef.componentInstance.googleReminder = this.googleReminder;
        modalRef.componentInstance.outlookReminder = this.outlookReminder;
        modalRef.componentInstance.yahooReminder = this.yahooReminder;
        modalRef.componentInstance.session = scheduleSessionResponse.session;
        modalRef.componentInstance.momentDate = this.momentDate;
    }
    // https://outlook.office.com/calendar/0/deeplink/compose?allday=false&body=Nice%20description&startdt=2022-10-25T21%3A15%3A00%2B00%3A00&enddt=2022-10-25T21%3A45%3A00%2B00%3A00&subject=Your Inuka session&location=Inuka&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent
    createCalendarReminders(session) {
        const calendarEventLinks = this.calendarEventLinkService.generateCalendarEventLinks(session);
        this.googleReminder = calendarEventLinks.google;
        this.outlookReminder = calendarEventLinks.outlook;
        this.yahooReminder = calendarEventLinks.yahoo;
    }
    refreshAvailabilities() {
        if (this.modalRef) {
            this.modalRef.close();
        }
        this.loadAvailableCoachSlots();
    }
    cancel() {
        this.onCancel.emit();
    }
    onSelectedSessionTypesChanged(selectedSessionTypes) {
        this.selectedSessionTypes = selectedSessionTypes;
        // if only video has been selected
        if ((selectedSessionTypes === null || selectedSessionTypes === void 0 ? void 0 : selectedSessionTypes.length) === 1 && selectedSessionTypes[0] === 'video') {
            this.isVideo = true;
        }
        else {
            this.isVideo = false;
        }
        this.selectedDayAvailableCoachSlots = null;
        this.loadAvailableCoachSlots();
    }
    onSelectedSessionLanguagesChanged(selectedLanguages) {
        var _a;
        if ((selectedLanguages === null || selectedLanguages === void 0 ? void 0 : selectedLanguages.toString()) !== ((_a = this.selectedSessionLanguages) === null || _a === void 0 ? void 0 : _a.toString())) {
            this.selectedSessionLanguages = selectedLanguages;
            this.loadAvailableCoachSlots();
        }
    }
    onSelectedDayChange(dayAvailableCoachSlots) {
        var _a;
        this.momentDate = null;
        this.confirmAttributes = null;
        if (this.selectedDayAvailableCoachSlots !== dayAvailableCoachSlots) {
            this.selectedDayAvailableCoachSlots = dayAvailableCoachSlots;
            this.selectedCoachIndex = -1;
            this.selectedSlotIndex = -1;
            if (!((_a = dayAvailableCoachSlots.coachesSlots) === null || _a === void 0 ? void 0 : _a.length)) {
                this.selectedDayAvailableCoachSlots = undefined;
                return;
            }
            this.changeAttributes = new ChangeAttributes();
            this.trackerService.sendActivity("book_change_date_btn_clicked");
        }
    }
    showNextPeriod() {
        if (this.availableCoachSlotsCalendar.nextPeriodStaringDay) {
            this.availablePeriodStart = this.availableCoachSlotsCalendar.nextPeriodStaringDay;
            this.loadAvailableCoachSlots();
        }
    }
    showPreviousPeriod() {
        if (this.availableCoachSlotsCalendar.previousPeriodStaringDay) {
            this.availablePeriodStart = this.availableCoachSlotsCalendar.previousPeriodStaringDay;
            this.loadAvailableCoachSlots();
        }
    }
    changeViewMode(viewMode) {
        if (viewMode !== this.viewMode) {
            this.viewMode = viewMode;
            this.initAvailablePeriodStartDay();
            this.loadAvailableCoachSlots();
        }
    }
    selectDefaultSessionDuration() {
        if (this.sessionDurationByType && this.sessionType) {
            const allowedDurations = this.sessionDurationByType[this.sessionType];
            if (allowedDurations === null || allowedDurations === void 0 ? void 0 : allowedDurations.length) {
                this.duration = allowedDurations[0];
            }
        }
    }
    selectSessionDuration(duration) {
        this.duration = duration;
    }
}
ScheduleSessionCoachComponent.ɵfac = function ScheduleSessionCoachComponent_Factory(t) { return new (t || ScheduleSessionCoachComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.UserVoucherService), i0.ɵɵdirectiveInject(i3.PricingService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.PaymentService), i0.ɵɵdirectiveInject(i6.AccountService), i0.ɵɵdirectiveInject(i7.SessionSettingService), i0.ɵɵdirectiveInject(i8.ActivatedRoute), i0.ɵɵdirectiveInject(i8.Router), i0.ɵɵdirectiveInject(i9.JhiEventManager), i0.ɵɵdirectiveInject(i10.JhiLanguageService), i0.ɵɵdirectiveInject(i11.TrackerService), i0.ɵɵdirectiveInject(i12.CoachDetailsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i13.SessionStorageService), i0.ɵɵdirectiveInject(i14.NgbModal), i0.ɵɵdirectiveInject(i15.CalendarEventLinkService)); };
ScheduleSessionCoachComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScheduleSessionCoachComponent, selectors: [["schedule-session-coach"]], viewQuery: function ScheduleSessionCoachComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
        i0.ɵɵviewQuery(_c5, 5);
        i0.ɵɵviewQuery(_c6, 5);
        i0.ɵɵviewQuery(_c7, 5);
        i0.ɵɵviewQuery(_c8, 5);
        i0.ɵɵviewQuery(_c9, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.warningSelectedTimeSlotIsNoLongerValidDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.alreadyFutureSessionDialogForCoach = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.okDialog = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentCancelledDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentCannotBeVerifiedDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paymentIsBeingProcessedDialogBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noCredit = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noCreditForCoach = _t.first);
    } }, inputs: { user: "user", coach: "coach", sessionId: "sessionId", sessionLanguage: "sessionLanguage" }, outputs: { onScheduleSession: "onScheduleSession", onScheduleSessionText: "onScheduleSessionText", onHourPressed: "onHourPressed", onCancel: "onCancel" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 12, vars: 6, consts: [[1, "row"], [1, "col", "px-lg-2"], ["isSmall", "true", 3, "availableCoachSlotsCalendar", "viewMode", "selectedDateChange", "showNextPeriod", "showPreviousPeriod", 4, "ngIf"], [1, "mt-4"], [1, "row", 2, "margin-left", "-25px", "margin-right", "-25px"], [4, "ngIf"], ["class", "row mt-2", 4, "ngIf"], ["class", "row", 4, "ngIf"], ["class", "row mt-3", 4, "ngIf"], ["warningSelectedTimeSlotIsNoLongerValidDialog", ""], ["isSmall", "true", 3, "availableCoachSlotsCalendar", "viewMode", "selectedDateChange", "showNextPeriod", "showPreviousPeriod"], [4, "ngFor", "ngForOf"], [1, "col", "p-1", "tab", "text-center", 3, "click"], ["style", "height: 14px; width: 14px; margin-right: 2px;", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.session.type.text", 1, "mb-0", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.durationValue", 3, "translateValues"], [2, "height", "14px", "width", "14px", "margin-right", "2px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#text-white"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#text-green"], ["style", "height: 14px; width: 14px; margin-right: 2px;margin-top: 4px;", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.session.type.video", 1, "mb-0", "text-center"], [2, "height", "14px", "width", "14px", "margin-right", "2px", "margin-top", "4px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#video-white"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#video-green"], [1, "row", "mt-2"], ["class", "col-4 col-sm-4 col-md-4 col-lg-3 p-0 p-lg-2 ", 4, "ngFor", "ngForOf"], [1, "col-4", "col-sm-4", "col-md-4", "col-lg-3", "p-0", "p-lg-2"], [1, "text-nowrap", "hour-number", 3, "ngClass", "disabled", "click"], [1, "col-12", "my-5", "text-center"], ["jhiTranslate", "sessionSchedule.paragraph.noCoachAvailableInNext6Month.title"], [1, "row", "mt-3"], [1, "col"], [1, "mb-3", 2, "border-top", "1px solid #9DB7B0"], [1, "col-4"], ["jhiTranslate", "sessionSchedule.paragraph.user", 1, "header"], [1, "col-8"], [1, "description"], ["jhiTranslate", "sessionSchedule.paragraph.sessionType", 1, "header"], [1, "d-flex", "justify-content-start", "align-items-center", "m-0"], [2, "height", "14px", "width", "14px", "margin", "0 5px 0 0px", 3, "ngStyle"], [0, "xlink", "href", ""], [1, "description", 3, "jhiTranslate"], ["jhiTranslate", "sessionSchedule.paragraph.date", 1, "header"], [2, "height", "18px", "width", "16px", "margin", "0 5px 0 0px"], ["jhiTranslate", "sessionSchedule.paragraph.dateValue", 1, "description", 3, "translateValues"], [1, "mt-3", "pt-3", 2, "border-top", "1px solid #9DB7B0"], [3, "sessionLanguageList", "sessionLanguage", "sessionLanguageChange"], [1, "mt-4", 2, "text-align", "center"], ["jhiTranslate", "sessionSchedule.button.cancel", 1, "btn", "btn-link", 3, "click"], ["id", "session-schedule-confirm-selection-btn", "jhiTranslate", "sessionSchedule.button.confirmSelection", "class", "btn btn-primary px-4 ml-3", 3, "click", 4, "ngIf"], ["id", "session-schedule-confirm-newtime-selection-btn", "jhiTranslate", "sessionSchedule.button.confirmNewTime", "class", "btn btn-primary px-4 ml-3", 3, "click", 4, "ngIf"], ["jhiTranslate", "sessionSchedule.paragraph.duration", 1, "header"], [2, "height", "18px", "width", "18px", "margin", "0 5px 0 0px"], ["jhiTranslate", "sessionSchedule.paragraph.durationValue", 1, "description", 3, "translateValues"], ["id", "session-schedule-confirm-selection-btn", "jhiTranslate", "sessionSchedule.button.confirmSelection", 1, "btn", "btn-primary", "px-4", "ml-3", 3, "click"], ["id", "session-schedule-confirm-newtime-selection-btn", "jhiTranslate", "sessionSchedule.button.confirmNewTime", 1, "btn", "btn-primary", "px-4", "ml-3", 3, "click"], [1, "modal-body"], ["jhiTranslate", "sessionSchedule.header.selectedTimeSlotIsNoLongerValid", 1, "title"], ["jhiTranslate", "sessionSchedule.dialog.selectedTimeSlotIsNoLongerValid", 1, "content"], [1, "modal-footer"], ["type", "button", "jhiTranslate", "sessionSchedule.button.refresh", "aria-label", "", 1, "btn", "btn-success", 3, "click"]], template: function ScheduleSessionCoachComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, ScheduleSessionCoachComponent_available_coach_slots_calendar_2_Template, 1, 2, "available-coach-slots-calendar", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, ScheduleSessionCoachComponent_ng_container_5_Template, 2, 1, "ng-container", 5);
        i0.ɵɵtemplate(6, ScheduleSessionCoachComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, ScheduleSessionCoachComponent_div_7_Template, 2, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, ScheduleSessionCoachComponent_div_8_Template, 3, 0, "div", 7);
        i0.ɵɵtemplate(9, ScheduleSessionCoachComponent_div_9_Template, 31, 16, "div", 8);
        i0.ɵɵtemplate(10, ScheduleSessionCoachComponent_ng_template_10_Template, 5, 0, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.availableCoachSlotsCalendar);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.sessionDurationByType == null ? null : ctx.sessionDurationByType.text);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.sessionDurationByType == null ? null : ctx.sessionDurationByType.video);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedDayAvailableCoachSlots == null ? null : ctx.selectedDayAvailableCoachSlots.coachesSlots == null ? null : ctx.selectedDayAvailableCoachSlots.coachesSlots.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.autoLookupTries === ctx.MAX_AUTO_LOOKUP_TRIES);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.momentDate);
    } }, directives: [i16.NgIf, i17.AvailableCoachSlotsCalendarComponent, i16.NgForOf, i18.JhiTranslateDirective, i16.NgClass, i16.NgStyle, i19.SessionLanguageRadioSelectorComponent], styles: [".header[_ngcontent-%COMP%]{font-weight:bold;font-family:Poppins,sans-serif;font-size:16px !important}.description[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif;font-size:16px !important}.day-number[_ngcontent-%COMP%]{opacity:1;border-radius:50%;width:2rem;height:2rem;background:transparent;border:0;color:var(--text);text-align:center}.day-number-selected[_ngcontent-%COMP%]{background-color:var(--main);color:#fff}.hour-number[_ngcontent-%COMP%]{background:transparent;border-radius:.3rem;color:var(--main);border:1px solid var(--main);padding:.3rem .2rem;width:90%}.hour-number-selected[_ngcontent-%COMP%]{background-color:var(--main);color:#fff}.tab[_ngcontent-%COMP%]{cursor:pointer;border:1px solid var(--main);color:var(--main);border-right:0}.tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:var(--main)}.tab[_ngcontent-%COMP%]:first-of-type{border-left:0}.selected-tab[_ngcontent-%COMP%]{background-color:var(--main);color:#fff !important}.selected-tab[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#fff !important}"] });
